<template>

  <div style="height: auto; margin: 15px 25px 15px 25px;">
    <br>
    <h1 class="pb-2 border-bottom">mKOLON4 관리자 앱 ({{plfTpNm}})</h1>
    <br>
    <div class="list-group w-auto">
      <template v-for="(item, index) in appList">
      <a :href="installUrl(`${item.appId}`)" class="list-group-item list-group-item-action d-flex gap-3 py-3" aria-current="true">
        <img :src="`${item.iconUrl}`" width="50" height="50" class="rounded-circle flex-shrink-0">
        <div class="d-flex gap-2 w-100 justify-content-between">
          <div>
            <h2 class="mb-1">{{ item.appNm }}</h2>
            <p class="mb-1 opacity-75">[{{ item.versionNm }}] {{ item.versionDesc }}</p>
          </div>
        </div>
      </a>
      </template>
    </div>
  </div>

</template>

<script>
import Util from "@/util/Util";
import axios from "axios";

export default {
  name: "Apps",
  data(){
    return {
      plfTpNm: 'android',
      appList: []
    }
  },
  computed: {
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      if (Util.isIOS()) {
        this.plfTpNm = 'ios'
      } else {
        this.plfTpNm = 'android'
      }
      this.getList()
    },
    getList() {
      axios({
        method: "get",
        url: process.env.APPS_URL + `/app/appserviceList?userId=mobilesuperpower&platformCd=${this.plfTpNm}&searchGb=1&orderGb=3`,
        headers: {
          "Content-Type": "application/json",
        }
      }).then(res => {
        this.appList = res.data.data.appList
      }).catch(function (error) {
        console.log(error)
      })
    },
    installUrl(appId) {
      if(Util.isIOS()){
        return `itms-services://?action=download-manifest&url=${process.env.COMN_URL}app/downByLatest/${appId}`
      }else{
        return `${process.env.COMN_URL}app/downByLatest/${appId}`
      }
    }
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/Apps.vue